import { render, staticRenderFns } from "./details-crumbs.vue?vue&type=template&id=4761a1b5&scoped=true"
import script from "./details-crumbs.vue?vue&type=script&lang=js"
export * from "./details-crumbs.vue?vue&type=script&lang=js"
import style0 from "./details-crumbs.vue?vue&type=style&index=0&id=4761a1b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4761a1b5",
  null
  
)

export default component.exports